import React from 'react';
import { useTranslation } from 'react-i18next';
import InputComponent from '../../components/InputMC';

const CreateFunnelStepOne = ({ onChange, data }) => {
  const { t } = useTranslation('Funnels');

  return (
    <InputComponent
      value={data?.name || ''}
      onChange={onChange}
      name="name"
      label={t('sidebar.createFromZero.stepOne.fields.name.inputLabel')}
      placeholder={t('sidebar.createFromZero.stepOne.fields.name.placeholder')}
      className="tw-resize-none"
      useFloatingLabel
    />
  );
};

export default CreateFunnelStepOne;
